import { Button } from "@k8slens/lds";
import { misc } from "@k8slens/lds-icons";

import { RepeatIcon } from "src/components/Icon/Navigation";
import { dateToString } from "src/utils/date";
import styles from "./PersonalSubscription.module.css";
import { planMetadata } from "../../../services/plans";
import { ActiveLensSubscription } from "./ActiveLensSubscription";
import { BillingInfo, SubscriptionSeat } from "lens-platform-sdk";
import { License, SubscriptionSeatWithBillingPeriod } from "./license";
import { useGetLicense } from "src/hooks/useGetLicense";

const { CreditCardIcon, EventIcon } = misc;

interface Props {
  license: ReturnType<typeof useGetLicense>;
  onLicenseChange?: () => void;
  onCancelSubscription?: (license: License) => void;
  billingInfoUrl?: string;
  accountUrl?: string;
  billingInfo?: BillingInfo | null;
  subscriptionSeats: SubscriptionSeat[];
  currentSubscriptionSeatWithBillingPeriod?: SubscriptionSeatWithBillingPeriod;
}

export function PersonalSubscription({ license, onCancelSubscription, onLicenseChange }: Props) {
  const cancelSubscription = async () => {
    if (onCancelSubscription && license) {
      onCancelSubscription(license);
    }
  };

  const billing = (
    <div className={styles.billing}>
      <ul>
        <li>
          <CreditCardIcon size="sm" />
          No Payment Method Required
        </li>
        <li>
          <RepeatIcon size="sm" />
          Automatic Renewal (Annual)
        </li>
        {license ? (
          <li>
            <EventIcon size="sm" />
            Next Renewal: {dateToString(license.expiration)}
          </li>
        ) : null}
      </ul>
      <div className={styles.buttons}>
        <Button label="Cancel Subscription" primary discreet onClick={() => cancelSubscription()} />
        <Button
          label="Change Lens Subscription"
          primary
          onClick={() => {
            if (onLicenseChange) {
              onLicenseChange();
            }
          }}
        />
      </div>
    </div>
  );

  return <ActiveLensSubscription licenseType="personal" features={planMetadata.personal.features} billing={billing} />;
}
